

export const SETTINGS_MODULES = [
  {
    key: "account-management",
    title: "Account Management",
    description: "Manage accounts, activate or deactivate accounts, and update account details.",
    route: "/watchtower/accounts",
    iconClassName: "settings-card-icon--accounts",
    iconKey: "accounts",
  },
  {
    key: "security-questions",
    title: "Security Questions",
    description: "Configure security questions used for password recovery and account verification.",
    route: "/watchtower/security-questions",
    iconClassName: "settings-card-icon--security",
    iconKey: "security",
  },
  {
    key: "configuration",
    title: "Configuration",
    description: "Manage project-level configurations and currency conversion settings.",
    route: "/watchtower/configuration",
    iconClassName: "settings-card-icon--configuration",
    iconKey: "configuration",
  },
];
